import { AuthGuard } from '@onesource/components';
import { getGetWpTokenQueryOptions, isLoggedIn, queryClient } from '@onesource/services';
import { createFileRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { WP_MEMBERS_SITE } from 'src/config';
import { DashboardLayout } from 'src/layouts/dashboard';
import { z } from 'zod';

const HomePage = lazy(() => import('src/pages/home'));

export const Route = createFileRoute('/')({
  validateSearch: z.object({
    return_url: z.string().optional().catch(undefined),
  }),

  beforeLoad: async ({ search }) => {
    const { return_url: returnUrl } = search;
    if (!returnUrl || !isLoggedIn()) {
      return;
    }

    const decodedReturnUrl = decodeURIComponent(returnUrl);

    if (!decodedReturnUrl.startsWith(WP_MEMBERS_SITE)) {
      return;
    }

    try {
      const { token: wpToken } = await queryClient.ensureQueryData(getGetWpTokenQueryOptions({}));
      window.location.href = `${WP_MEMBERS_SITE}/verify-token?token=${wpToken}&redirect_url=${encodeURIComponent(decodedReturnUrl)}&wp_token=true`;
    } catch (error) {
      console.error('[WP Redirect] Failed to generate WP token:', error);
    }
  },
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <HomePage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
